import { gql } from '../../__generated__';

export const GET_PROPERTY_TRANSACTIONS = gql(/* GraphQL */ `
  query getPropertyTransactions(
    $where: property_transactions_bool_exp!
    $order_by: [property_transactions_order_by!]
    $limit: Int!
    $offset: Int!
    $team_ids: [uuid!]!
  ) {
    property_transactions(
      where: $where
      order_by: $order_by
      limit: $limit
      offset: $offset
    ) {
      ...TransactionsListRow
      reviews(where: { completed: { _eq: true } }) {
        id
        is_buyer
      }
    }
  }
`);

export const GET_PROPERTY_TRANSACTIONS_LIST_COUNT = gql(/* GraphQL */ `
  query getPropertyTransactionsListCount(
    $where: property_transactions_bool_exp!
  ) {
    property_transactions_aggregate(where: $where) {
      aggregate {
        count
      }
    }
  }
`);

export const DRAWER_GET_PROPERTY_TRANSACTION = gql(/* GraphQL */ `
  query TransactionDrawerGetTransaction($id: uuid!) {
    property_transactions_by_pk(id: $id) {
      id
      lot_id
      property_id
      buyer_broker_team_id
      seller_broker_team_id
    }
  }
`);

export const DELETE_TRANSACTION = gql(/* GraphQL */ `
  mutation DeleteTransaction($id: uuid!) {
    delete_property_transactions_by_pk(id: $id) {
      id
    }
  }
`);

export const TRANSACTION_FORM_FRAGMENT = gql(/* GraphQL */ `
  fragment TransactionFormFragment on property_transactions {
    id
    created_by
    created_at
    signature_date
    signature_date
    buyer_broker_id
    seller_broker_id
    buyer_broker_team_id
    seller_broker_team_id
    signature_date
    estimated_signature_date
    payment_date
    purchase_price
    is_published
    lot_id
    lot {
      id
      currency
      property {
        id
        country_code
      }
    }
    sellers {
      transaction_id
      user_id
    }
    buyers {
      transaction_id
      user_id
    }
  }
`);

export const TRANSACTION_COMMISSIONS_FORM_FRAGMENT = gql(/* GraphQL */ `
  fragment TransactionCommissionsFormFragment on property_transactions {
    id
    purchase_price
    commissions(order_by: { payment_date: asc }) {
      id
      type
      amount
      vat
      contact_id
      beneficiary_team_id
    }
    lot {
      id
      currency
      mandate_type
      property {
        id
        country_code
      }
    }
  }
`);

export const TRANSACTION_FORM_QUERY = gql(/* GraphQL */ `
  query TransactionFormQuery($id: uuid!) {
    property_transactions_by_pk(id: $id) {
      id
      ...TransactionFormFragment
    }
  }
`);

export const TRANSACTION_FORM_UPDATE = gql(/* GraphQL */ `
  mutation TransactionFormUpdate(
    $id: uuid!
    $transaction: property_transactions_set_input!
    $sellers: [transaction_sellers_insert_input!]!
    $buyers: [transaction_buyers_insert_input!]!
  ) {
    update_property_transactions_by_pk(
      pk_columns: { id: $id }
      _set: $transaction
    ) {
      id
      ...TransactionFormFragment
      seller_broker {
        id
        ...UserInfo_user
      }
      buyer_broker {
        id
        ...UserInfo_user
      }
      buyer_broker_team {
        id
        ...TeamInfo_team
      }
      seller_broker_team {
        id
        ...TeamInfo_team
      }
    }
    delete_transaction_buyers(where: { transaction_id: { _eq: $id } }) {
      returning {
        transaction_id
        user_id
      }
    }
    delete_transaction_sellers(where: { transaction_id: { _eq: $id } }) {
      returning {
        transaction_id
        user_id
      }
    }
    insert_transaction_buyers(objects: $buyers) {
      returning {
        transaction_id
        user_id
      }
    }
    insert_transaction_sellers(objects: $sellers) {
      returning {
        transaction_id
        user_id
      }
    }
  }
`);

export const TRANSACTION_COMMISSIONS_FORM_UPDATE = gql(/* GraphQL */ `
  mutation TransactionCommissionsFormUpdate(
    $id: uuid!
    $commissions: [commissions_insert_input!]!
  ) {
    delete_commissions(where: { property_transaction_id: { _eq: $id } }) {
      returning {
        id
        type
        amount
        vat
        contact_id
        beneficiary_team_id
        property_transaction_id
      }
    }
    insert_commissions(objects: $commissions) {
      returning {
        id
        type
        amount
        vat
        contact_id
        beneficiary_team_id
        property_transaction_id
      }
    }
  }
`);

export const CREATE_TRANSACTION = gql(/* GraphQL */ `
  mutation CreateTransaction(
    $transaction: property_transactions_insert_input!
  ) {
    insert_property_transactions_one(object: $transaction) {
      id
      ...TransactionFormFragment
      seller_broker {
        id
        ...UserInfo_user
      }
      buyer_broker {
        id
        ...UserInfo_user
      }
      buyer_broker_team {
        id
        ...TeamInfo_team
      }
      seller_broker_team {
        id
        ...TeamInfo_team
      }
      property {
        id
      }
      buyers {
        user_id
        transaction_id
      }
      sellers {
        user_id
        transaction_id
      }
    }
  }
`);

export const GET_USER_DEFAULT_TEAM_ID = gql(/* GraphQL */ `
  query GetUserDefaultTeamId($id: uuid!) {
    users_by_pk(id: $id) {
      default_team_id
    }
  }
`);

export const GET_TRANSACTION_DOCUMENTS = gql(/* GraphQL */ `
  query GetTransactionDocuments($id: uuid!) {
    property_transactions_by_pk(id: $id) {
      id
      property {
        id
        property_files(order_by: { order_nr: desc }) {
          ...PropertyFile
        }
      }
    }
  }
`);

export const GET_TRANSACTION_PROPERTY = gql(/* GraphQL */ `
  query GetTransactionProperty($id: uuid!) {
    property_transactions_by_pk(id: $id) {
      id
      ...TransactionCard
    }
  }
`);

export const DELETE_PROPERTY_TRANSACTION_LISTING = gql(/* GraphQL */ `
  mutation DeletePropertyTransactionListing($id: uuid!, $listingId: Int!) {
    delete_property_transactions_listings(
      where: {
        property_transaction_id: { _eq: $id }
        listing_id: { _eq: $listingId }
      }
    ) {
      affected_rows
      returning {
        property_transaction_id
        listing_id
      }
    }
  }
`);

export const GET_LINKED_LISTINGS = gql(/* GraphQL */ `
  query GetLinkedListings(
    $ids: [Int!]!
    $ch: Boolean!
    $es: Boolean!
    $fr: Boolean!
    $it: Boolean!
  ) {
    ch_cma_listings(where: { id: { _in: $ids } }) @include(if: $ch) {
      id
      number_of_rooms
      number_of_bathrooms
      computed_surface
      land_surface
      sale_price
      computed_price_per_sqm
      offline_since
      created_at
      country_code
      address
      route
      street_number
      postcode
      locality
      state_id
      visit_contact_person
      agency_contact_person
      agency_name
      places {
        id
        label
      }
      property_type
      images(limit: 1, order_by: [{ image_index: asc_nulls_last }]) {
        id
        file_name
        bucket_name
      }
      created_at
      valid_from
      offline_since
    }

    fr_cma_listings(where: { id: { _in: $ids } }) @include(if: $fr) {
      id
      number_of_rooms
      number_of_bathrooms
      computed_surface
      land_surface
      sale_price
      computed_price_per_sqm
      offline_since
      created_at
      country_code
      address
      route
      street_number
      postcode
      locality
      state_id
      visit_contact_person
      agency_contact_person
      agency_name
      places {
        id
        label
      }
      property_type
      images(limit: 1, order_by: [{ image_index: asc_nulls_last }]) {
        id
        file_name
        bucket_name
      }
      created_at
      valid_from
      offline_since
    }
    es_cma_listings(where: { id: { _in: $ids } }) @include(if: $es) {
      id
      number_of_rooms
      number_of_bathrooms
      computed_surface
      land_surface
      sale_price
      computed_price_per_sqm
      offline_since
      created_at
      country_code
      address
      route
      street_number
      postcode
      locality
      state_id
      visit_contact_person
      agency_contact_person
      agency_name
      places {
        id
        label
      }
      property_type
      images(limit: 1, order_by: [{ image_index: asc_nulls_last }]) {
        id
        file_name
        bucket_name
      }
      created_at
      valid_from
      offline_since
    }
    it_cma_listings(where: { id: { _in: $ids } }) @include(if: $it) {
      id
      number_of_rooms
      number_of_bathrooms
      computed_surface
      land_surface
      sale_price
      computed_price_per_sqm
      offline_since
      created_at
      country_code
      address
      route
      street_number
      postcode
      locality
      state_id
      visit_contact_person
      agency_contact_person
      agency_name
      places {
        id
        label
      }
      property_type
      images(limit: 1, order_by: [{ image_index: asc_nulls_last }]) {
        id
        file_name
        bucket_name
      }
      created_at
      valid_from
      offline_since
    }
  }
`);

export const INSERT_PROPERTY_TRANSACTION_LISTINGS = gql(/* GraphQL */ `
  mutation InsertPropertyTransactionListings(
    $objects: [property_transactions_listings_insert_input!]!
  ) {
    insert_property_transactions_listings(
      objects: $objects
      on_conflict: {
        constraint: property_transactions_listings_pkey
        update_columns: [updated_at]
      }
    ) {
      returning {
        property_transaction_id
        property_transaction {
          id
          property_transactions_listings {
            property_transaction_id
            listing_id
          }
        }
        listing_id
      }
    }
  }
`);
